import { FuiBodyTextComponent } from "./body-text/body-text.component";
import { FuiHeadingComponent } from "./heading/heading.component";
import { FuiButtonComponent } from "./button/button.component";
import { FuiCardComponent } from "./card/card.component";
import { FuiFooterComponent } from "./footer/footer.component";
import { FuiContentFilterComponent } from "./content-filter/content-filter.component";
import { FuiLayoutHeaderComponent } from "./layout-header/layout-header.component";

export const FENDERUI_COMPONENTS = [FuiBodyTextComponent, FuiHeadingComponent, FuiButtonComponent, FuiCardComponent, FuiFooterComponent, FuiContentFilterComponent, FuiLayoutHeaderComponent];

export * from "./body-text/body-text.component";
export * from "./heading/heading.component";
export * from "./button/button.component";
export * from "./card/card.component";
export * from "./footer/footer.component";
export * from "./content-filter/content-filter.component";
export * from "./layout-header/layout-header.component";
